/**
 * Phase 2 Feature H — next-best actions from bundle (asks / exam / orders).
 */

/**
 * @param {import('./ddxTypes.js').DdxKnowledgeBundle} bundle
 * @param {number} [maxActions]
 * @returns {import('./ddxTypes.js').NextBestAction[]}
 */
export function synthesizeNextBestActions(bundle, maxActions = 12) {
  if (!bundle) return [];
  const top = (bundle.candidates || []).slice(0, 5).map((c) => c.diagnosisId);
  const actions = [];

  for (const m of bundle.expectedButMissing || []) {
    if (!top.includes(m.diagnosisId)) continue;
    const urgent = (m.sensitivity || 0) >= 0.85 || m.clinicalSignificance === 'rule_out_if_absent';
    actions.push({
      action: m.featureId?.includes('lab') || m.featureId?.includes('troponin') ? 'order' : 'ask',
      target: m.featureLabel || m.featureId,
      discriminatingQuestion: m.featureLabel ? `Clarify or document: ${m.featureLabel}?` : null,
      differentiatesBetween: [m.diagnosisId],
      priorityScore: (m.sensitivity || 0.5) * (urgent ? 1.2 : 1),
      temporalUrgency: urgent ? 'urgent' : 'routine',
      timeWindowNote: null,
    });
  }

  for (const c of bundle.candidates || []) {
    if (!c.isCantMiss) continue;
    actions.push({
      action: 'examine',
      target: c.label,
      discriminatingQuestion: null,
      differentiatesBetween: [c.diagnosisId],
      priorityScore: 0.95,
      temporalUrgency: 'immediate',
      timeWindowNote: "Can't-miss consideration — ensure explicit evaluation",
    });
  }

  actions.sort((a, b) => b.priorityScore - a.priorityScore);
  return actions.slice(0, maxActions);
}
